<template>
    <div class="list">
      <div class="classify" :title="title">{{title}}</div>
      <ul>
        <li v-for="(item,index) in items" :items="items" :key="index" @click="$router.push(item.url)" style="cursor:pointer">
        {{item.listName}}<!-- &nbsp;<Icon type="ios-arrow-forward" size="24" /> -->
        </li>
      </ul>
    </div>
</template>

<script>
export default {
  name: 'List',
  props: {
    items: {
      type: Array,
      default () {
        return []
      }
    },
    title: {
      type: String,
      default () {
        return ''
      }
    }
  }
}
</script>

<style scoped>
  ul {
    list-style-type: none;
    background: #FFFFFF;
    margin: 0 auto;
    width: 180px;
    padding: 20px 0px;
  }
  li {
    padding-bottom: 20px;
    text-align: center;
    height: 50px;
    line-height: 50px;
    font-size: 15px;
  }
  .list {
    width: 275px;
    float: left;
  }
  .classify {
    width: 180px;
    height: 100px;
    background: #2F669A;
    font-size: 25px;
    color: #FFFFFF;
    text-align: center;
    line-height: 100px;
    margin: 0 auto;
    box-shadow:5px 5px 10px gray;
    margin-bottom: 20px;
  }
  @media screen and (max-width:1920px) {
    
  }
  @media screen and (max-width:1200px) {
    .list {
      width: 180px;
      float: left;
    }
  }
  @media screen and (max-width:992px) {
    .list {
      width: 180px;
      float: left;
    }
  }
</style>
